import { autoinject, bindable } from 'aurelia-framework';
import './status-dot.scss';

export type StatusDotType = 'ok' | 'error' | 'warning' | 'info' | 'stale';

@autoinject
export class StatusDot {
  @bindable()
  protected status: StatusDotType = 'ok';

  @bindable()
  tooltip: string | undefined;
}
